import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { initializeApp } from 'firebase/app';

initializeApp(environment.firebase);

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZonelessChangeDetection()] })
  .catch((err: any): void => console.error(err));

registerLocaleData(localeFr, 'fr');
